import { render } from "./RolePermission.vue?vue&type=template&id=f00ed946&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"

import "./RolePermission.vue?vue&type=style&index=0&id=f00ed946&scoped=true&lang=css"
import "./RolePermission.vue?vue&type=style&index=1&id=f00ed946&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00ed946"]])

export default __exports__